import {
  AutoComplete,
  Avatar,
  Button,
  Drawer,
  Form,
  Input,
  Select,
  Spin,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import {
  getImgUrl,
  getPage,
  getParamValue,
  jcTypeArray,
} from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import TopHeading from "./TopHeading";
import { debounce } from "lodash";
import Empty from "../common/Empty";
import AddCategory from "./AddCategory";
import { EditOutlined } from "@ant-design/icons";
const { Option } = Select;

const GlobalCategoryList = () => {
  const [type, setType] = useState("JC_MART");
  const [confirmLoading, setConfirmLoading] = useState(undefined);
  const [visible, setVisible] = useState(undefined);
  const [key, setKey] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(undefined);
  const [selectedCategoryForEdit, setSelectedCategoryForEdit] =
    useState(undefined);
  const [status, setStatus] = useState("");
  const [limit, setLimit] = useState(16);

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");

  const [categoryOptions, setCategoryOptions] = useState({
    loading: false,
    list: [],
  });

  const [categoryData, setCategoryData] = useState({
    loading: false,
    data: null,
  });

  const getCategories = useCallback(async () => {
    setCategoryData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/admin/category/parent-by-type?page=${page || 0}&limit=${
          limit || 16
        }` +
          (type ? `&type=${type}` : ``) +
          (status ? `&status=${status}` : ``) +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setCategoryData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setCategoryData({ loading: false, data: [] });
        console.error("Category: Error", err);
      });
  }, [limit, status, page, type, key]);

  const getCategoriesOptions = useCallback(
    async (key?: string) => {
      setCategoryOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      const res = await axios.get(
        `${encodedUri}/admin/category/parent-by-type?page=0&limit=20&isParent=false` +
          (key ? `&key=${key}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setCategoryOptions({
        loading: false,
        list: res.data?.categories?.map((category) => ({
          label: category.title,
          value: category.title,
        })),
      });
    },
    [type]
  );

  useEffect(() => {
    getCategories();
    getCategoriesOptions();
  }, [getCategories, getCategoriesOptions]);

  useEffect(() => {
    if (visible) {
      setSelectedCategory(undefined);
      setSelectedCategoryForEdit(undefined);
    }
  }, [selectedCategory, selectedCategoryForEdit, visible]);

  useEffect(() => {
    setSelectedCategory(undefined);
    setSelectedCategoryForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedCategory(null);
    setSelectedCategoryForEdit(null);
    getCategories();
  };

  const fetchRef = useRef(0);

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (value) {
        if (field === "category") getCategoriesOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [getCategoriesOptions]);

  const reseAllFieldData = () => {
    setStatus("");
    setKey("");
    form.resetFields();
  };

  return (
    <React.Fragment>
      <TopHeading
        total={categoryData?.data?.totalElements}
        refetch={getCategories}
      />
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item initialValue={type}>
            <Select
              placeholder="Product Type"
              onChange={(val) => setType(val)}
              value={type}
              style={{ minWidth: 300 }}
            >
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Option value={type} key={i}>
                  {type?.replace("_", " ")}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="area" initialValue={key}>
            <AutoComplete
              onSearch={(e) => handleSearch(e, "category")}
              onSelect={(val) => setKey(val)}
              options={categoryOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                categoryOptions?.loading ? <Spin size="small" /> : null
              }
              style={{ minWidth: 300 }}
            >
              <Input.Search
                size="large"
                placeholder="Search by Name"
                onSearch={(val) => {
                  setKey(val);
                  console.log(val);
                }}
                enterButton
                loading={categoryOptions.loading}
                pattern={`[0-9]`}
                maxLength={11}
              />
            </AutoComplete>
          </Form.Item>
        </Form>
        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading major">
                    <span>Category</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Type</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {categoryData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {categoryData?.data?.categories?.length ? (
                    categoryData?.data?.categories?.map(
                      (category: any, index: any) => (
                        <React.Fragment key={index}>
                          <Link
                            to={`/global-categories/${category?.id}/details`}
                          >
                            <div className="single-product-wrapper">
                              <div className="single-product major">
                                <Avatar
                                  shape="square"
                                  size={45}
                                  src={getImgUrl(category?.image)}
                                  className="mr-3"
                                />
                                <span className="name">
                                  {category?.title?.toUpperCase()}
                                </span>
                              </div>
                              <div className="single-product">
                                <span className="name">
                                  {category?.type?.split("_").join(" ")}
                                </span>
                              </div>

                              {/* <div className="single-product">
                                <Switch
                                  checkedChildren={<CheckOutlined />}
                                  unCheckedChildren={<CloseOutlined />}
                                  defaultChecked={!category?.deleted}
                                  onChange={(val, e) => {
                                    e.preventDefault();
                                    onDelete(category?.id, val);
                                  }}
                                  loading={
                                    confirmLoading &&
                                    category?.id === confirmLoading
                                  }
                                />
                              </div> */}

                              <div className="single-product">
                                <Button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedCategoryForEdit(category?.id);
                                  }}
                                >
                                  <EditOutlined />
                                </Button>
                              </div>
                            </div>
                          </Link>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Category" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title={"Edit Category"}
            width={600}
            onClose={() => {
              setSelectedCategory(null);
              setSelectedCategoryForEdit(null);
            }}
            visible={selectedCategory || selectedCategoryForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedCategoryForEdit ? (
              <AddCategory
                onCloseMethod={onClose}
                visibleData={selectedCategoryForEdit}
              />
            ) : undefined}
          </Drawer>

          <PaginationTwo
            {...categoryData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default GlobalCategoryList;
